/* eslint-disable internal-rules/no-hardcoded-colors */
import { i18n_t as $t } from '@/utils/i18n';

export const getPendoColorNamesMap = () => ({
    regular: {
        gray: $t('pendoColors.gray'),
        pink: $t('pendoColors.pink'),
        mauve: $t('pendoColors.mauve'),
        orange: $t('pendoColors.orange'),
        yellow: $t('pendoColors.yellow'),
        yellowOrange: $t('pendoColors.yellow_orange'),
        green: $t('pendoColors.green'),
        indigo: $t('pendoColors.indigo'),
        blue: $t('pendoColors.blue'),
        purple: $t('pendoColors.purple'),
        teal: $t('pendoColors.teal'),
        red: $t('pendoColors.red'),
        lime: $t('pendoColors.lime'),
        magenta: $t('pendoColors.magenta'),
    },
    dark: {
        gray: $t('pendoColors.dark gray'),
        pink: $t('pendoColors.dark pink'),
        orange: $t('pendoColors.dark orange'),
        yellow: $t('pendoColors.dark yellow'),
        green: $t('pendoColors.dark green'),
        blue: $t('pendoColors.dark blue'),
        purple: $t('pendoColors.dark purple'),
        teal: $t('pendoColors.dark teal'),
        red: $t('pendoColors.dark red'),
        lime: $t('pendoColors.dark lime'),
        magenta: $t('pendoColors.dark magenta'),
    },
    light: {
        gray: $t('pendoColors.light gray'),
        pink: $t('pendoColors.light pink'),
        orange: $t('pendoColors.light orange'),
        yellow: $t('pendoColors.light yellow'),
        green: $t('pendoColors.light green'),
        indigo: $t('pendoColors.light indigo'),
        blue: $t('pendoColors.light blue'),
        purple: $t('pendoColors.light purple'),
        teal: $t('pendoColors.light teal'),
        red: $t('pendoColors.light red'),
        lime: $t('pendoColors.light lime'),
        magenta: $t('pendoColors.light magenta'),
    },
});
